/**
 * @generated SignedSource<<e76a5c4991d8ec7025173d4842174397>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type colorPickerView_palettesListFragment$data = {
  readonly palettesWithColors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly colors: ReadonlyArray<{
          readonly colorID: number;
          readonly name: string;
          readonly rgbHexCode: string;
          readonly spotColorName: string | null;
        }>;
        readonly id: string;
        readonly name: string;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "colorPickerView_palettesListFragment";
};
export type colorPickerView_palettesListFragment$key = {
  readonly " $data"?: colorPickerView_palettesListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"colorPickerView_palettesListFragment">;
};

import colorPickerView_palettesListPaginationQuery_graphql from './colorPickerView_palettesListPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "palettesWithColors"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": 20,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cursor"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "paletteTypeID"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "cursor",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "cursor"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": colorPickerView_palettesListPaginationQuery_graphql
    }
  },
  "name": "colorPickerView_palettesListFragment",
  "selections": [
    {
      "alias": "palettesWithColors",
      "args": [
        {
          "kind": "Literal",
          "name": "numberOfColorsToShow",
          "value": 6
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": "DESC"
        },
        {
          "kind": "Variable",
          "name": "paletteTypeID",
          "variableName": "paletteTypeID"
        }
      ],
      "concreteType": "PalettesWithColorsConnection",
      "kind": "LinkedField",
      "name": "__colorPickerView_palettesList_palettesWithColors_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PalettesWithColorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Palette",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                (v1/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PaletteColor",
                  "kind": "LinkedField",
                  "name": "colors",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "colorID",
                      "storageKey": null
                    },
                    (v1/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "rgbHexCode",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "spotColorName",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "88f0279fe097c549e6876ce8270cbc1b";

export default node;
